<template>
	<div class="select-student flex start-v">
		<!-- 搜索框 -->
		<div class="search flex between">
			<input v-model="params.param" maxlength="20" type="text" placeholder="搜索" />
			<img @click="params.pageNo=1,studentList=[],getStudents()" src="@img/icon/ui_search.png" alt />
		</div>
		<p class="add-tips">添加学生</p>
		<div class="student-box flex start-v">
			<div class="count flex between">
				<!-- group-type -->
				<span class="flex">{{titleList[groupType]}}</span>
				<span>
					<span>{{count}}</span>/{{total}}
				</span>
			</div>
			<div class="row head flex between">
				<span>学号</span>
				<span>姓名</span>
				<span></span>
			</div>
			<div v-bottom="nextPage" class="list">
				<div v-if="!studentList?.length" class="nodata"></div>
				<div v-for="(item,index) in studentList" @click="selectStudent(item)" :key="index" class="row head flex between">
					<span>{{item?.number}}</span>
					<span class="text-ellipsis">{{item?.name||'无名'}}</span>
					<span class="flex">
						<input :checked="selectStudents.idList[`group${groupType}`]&&selectStudents.idList[`group${groupType}`].includes(item?.id)" type="checkbox" />
					</span>
				</div>
			</div>
		</div>

		<button @click="save" class="btn-full">保存</button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			groupType: 0,
			titleList: ["不及格组", "提高组", "高级组"],
			params: {
				type: 1, // 0_所有 1_未绑定班级的
				// gradeId: undefined,
				teamId: undefined,//班级ID
				groupStudent: undefined,
				param: undefined,
				pageNo: 1,
				pageSize: 20,
			},
			pages: 0,
			total: 0,
			studentList: [],

			selectStudents: {
				idList: {
					group0: [],
					group1: [],
					group2: [],
				},
				objList: {
					group0: [],
					group1: [],
					group2: [],
				},
			},
		};
	},

	computed: {
		count() {
			let arr = this.selectStudents.idList[`group${this.groupType}`];
			return arr ? arr.length : 0;
		},
		endPage() {
			return this.pages && this.pages <= this.params.pageNo;
		},
	},

	mounted() {
		this.params.teamId = this.$route.query.gradeId||undefined;
		this.params.type = this.$route.query.studentType||0;

		
		let { gradeId, groupType } = this.$route.query;
		this.groupType = groupType;
		this.params.groupStudent = groupType;
		if (localStorage.getItem("selectStudents")) {
			this.selectStudents = JSON.parse(
				localStorage.getItem("selectStudents")
			);
		}
		this.getStudents();
	},

	methods: {
		nextPage() {
			if (this.params.pageNo >= this.pages) return;
			this.params.pageNo++;
			console.log("nextPage");
		},
		toGrade(item) {
			this.$router.push({
				path: "/manager/course/grade",
				query: { courseInfo: JSON.stringify(item) },
			});
		},
		selectStudent(studentItem) {
			let idArr = this.selectStudents.idList[`group${this.groupType}`];
			let objArr = this.selectStudents.objList[`group${this.groupType}`];

			if (idArr.includes(studentItem.id)) {
				this.selectStudents.idList[`group${this.groupType}`] =
					idArr.filter((id) => {
						return id != studentItem.id;
					});
				this.selectStudents.objList[`group${this.groupType}`] =
					objArr.filter((item) => {
						return item.id != studentItem.id;
					});
			} else {
				this.selectStudents.idList[`group${this.groupType}`] =
					idArr.concat([studentItem.id]);
				this.selectStudents.objList[`group${this.groupType}`] =
					objArr.concat([studentItem]);
			}
			console.log(this.selectStudents);
		},

		save() {
			if (this.selectStudents.idList[`group${this.groupType}`].length ===0){
				return this.$message("请选择学生");
			}
				
			localStorage.setItem(
				"selectStudents",
				JSON.stringify(this.selectStudents)
			);
			this.$router.go(-1);
		},

		async getStudents() {
			this.params = this.params||'';
			try {
				let { success, message, result } = await this.$http.get(
					"h5/general/pageGroupStudent",
					{ params: this.params }
				);
				if (!success) throw new Error(message);
				this.pages = result.pages;
				this.total = result.total;
				this.studentList = this.studentList.concat(result.records);
			} catch (error) {
				console.log("getStudents", error?.message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.select-student {
	height: 100%;
	padding: 14 / @rem;
	p.add-tips {
		width: 100%;
		padding: 20 / @rem 0 14 / @rem;
		font-size: 16px;
		font-weight: bold;
	}
	.search {
		width: 100%;
		position: relative;
		input {
			padding: 0 45 / @rem 0 16 / @rem;
			width: 100%;
			height: 42 / @rem;
			font-size: 14 / @rem;
			border-radius: 21 / @rem;
			background-color: #f3f3f3;
			&::placeholder {
				color: rgba(23, 24, 25, 0.2);
			}
		}
		img {
			position: absolute;
			right: 20 / @rem;
			width: 19 / @rem;
			height: 19 / @rem;
			object-fit: contain;
		}
	}

	.student-box {
		width: 100%;
		overflow-y: auto;
		flex: 1;
		padding: 15 / @rem;
		border-radius: 12 / @rem;
		background-color: rgba(255, 246, 233, 1);
		.list {
			width: 100%;
			flex: 1;
			overflow-y: auto;
		}

		.row {
			width: 100%;
			padding: 5 / @rem;
			font-family: SourceHanSansCN-Regular;
			span:nth-child(1) {
				width: 120 / @rem;
			}
			span:nth-child(2) {
				flex: 1;
			}
			span:nth-child(3) {
				min-width: 20 / @rem;
			}
			input[type="checkbox"] {
				-webkit-appearance: none;
				display: inline-block;
				width: 17 / @rem;
				height: 17 / @rem;
				border-radius: 50%;
				border: 1 / @rem solid rgba(31, 30, 29, 0.3);
				&:checked {
					border: 1 / @rem solid rgba(255, 162, 22, 1);
					background-color: rgba(255, 162, 22, 1);
					position: relative;
					&::after {
						content: "";
						display: inline-block;
						position: absolute;
						left: 50%;
						top: 50%;
						margin-left: -4 / @rem;
						margin-top: -4 / @rem;
						width: 9 / @rem;
						height: 7 / @rem;
						background-image: url(~@img/icon/btn_xzzq.png);
						background-size: cover;
						background-repeat: no-repeat;
					}
				}
			}
		}
		.count {
			font-size: 15 / @rem;
			padding-bottom: 11 / @rem;
			span:nth-child(2) {
				color: rgba(23, 24, 25, 0.6);
			}
			.group-type {
				position: relative;
				padding-left: 26 / @rem;
				&::before {
					content: "";
					display: inline-block;
					position: absolute;
					left: 0%;
					width: 17 / @rem;
					height: 17 / @rem;
					border-radius: 50%;
					border: 1 / @rem solid rgba(31, 30, 29, 0.3);
				}

				&.active {
					&::after {
						content: "";
						display: inline-block;
						position: absolute;
						left: 50%;
						top: 50%;
						margin-left: -4 / @rem;
						margin-top: -4 / @rem;
						width: 9 / @rem;
						height: 7 / @rem;
						background-image: url(~@img/icon/btn_xzzq.png);
						background-size: cover;
						background-repeat: no-repeat;
					}
				}
			}
		}
	}

	.btn-full {
		margin-top: 12 / @rem;
	}
}
</style>
